import {
  StyledInfoIcon,
  StyledUpgradeBannerContainer,
  StyledUpgradeBannerHeader,
  StyledUpgradeBannerButton,
  StyledTitle,
  StyledDescription,
  StyledUpgradeBannerWrapper,
} from './styled';
import { PRICING_PATH } from '../../../../constants';

const UpgradeBanner = () => (
  <>
    <StyledUpgradeBannerContainer>
      <StyledUpgradeBannerWrapper>
        <StyledInfoIcon />
        <StyledUpgradeBannerHeader>
          <StyledTitle>Limited Access Account</StyledTitle>
          <StyledDescription>
            Upgrade to a paid plan or buy credits for unlimited access and
            higher rate limits.
          </StyledDescription>
          <StyledUpgradeBannerButton to={PRICING_PATH}>
            View Pricing and Plans
          </StyledUpgradeBannerButton>
        </StyledUpgradeBannerHeader>
      </StyledUpgradeBannerWrapper>
    </StyledUpgradeBannerContainer>
  </>
);

export default UpgradeBanner;
